import React from 'react';
import spinnerBase from './spinnerBase.svg';

export const SpinnerIcon = ({ i18n }) => (<img
  src={spinnerBase}
  alt={i18n.getString(_TL_('spinner'))}
  className="spinner-icon"
/>);
